var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cps"}},[_c('div',{staticClass:"content_box"},[_c('div',{staticClass:"inner"},[(_vm.isIBT)?_c('InternationalBank'):(_vm.isCC)?_c('CreditCard'):_c('CPS')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }